export default "__VITE_ASSET__C8S6Jmiv__"